import axios from 'axios';
import {jwtDecode} from 'jwt-decode';

// Axios példány létrehozása
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Az API alap URL-je a környezeti változóból
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // Hitelesítési adatok engedélyezése
});

// Token lekérése (no refresh token)
const getToken = () => localStorage.getItem('access_token');

// Felhasználó kijelentkeztetése és átirányítás a bejelentkezési oldalra
const logoutUser = () => {
  localStorage.removeItem('access_token');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

// Axios interceptor a token hozzáadásához
api.interceptors.request.use(
  async (config) => {
    let token = getToken();

    // Ellenőrizzük a token lejárati idejét
    if (token) {
      const decoded = jwtDecode(token);
      const isTokenExpired = decoded.exp * 1000 < Date.now();

      if (isTokenExpired) {
        // Token expired - logout user immediately (no refresh token available)
        console.log('Access token expired, logging out user');
        logoutUser();
        return Promise.reject(new Error("Token expired, logging out."));
      }

      // Add valid token to request
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // No token available - redirect to login
      logoutUser();
      return Promise.reject(new Error("No token available, logging out."));
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Axios interceptor a hibakezeléshez (401 hiba esetén kijelentkeztetés)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Ha a hiba 401-es (Unauthorized), az azt jelenti, hogy lejárt a token
    if (error.response && error.response.status === 401) {
      console.log('Received 401 error, logging out user');
      logoutUser();
      return Promise.reject(error);
    }

    return Promise.reject(error); 
  }
);

export default api;
